import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: `/dashboard`,
    pathMatch: 'full',
  },
  {
    path: 'overview',
    loadChildren: () =>
      import('./overview/overview.module').then((m) => m.OverviewModule),
  },
  {
    path: 'industry-selection',
    pathMatch: 'full',
    loadChildren: () =>
      import('./industry-selection/industry-selection.module').then((m) => m.IndustrySelectionModule),
  },
  {
    path: 'login',
    pathMatch: 'full',
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'dashboard',
    pathMatch: 'full',
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
  {
    path: 'admin/manage-user-accounts',
    pathMatch: 'full',
    loadChildren: () =>
      import('./admin/manage-user-accounts/manage-user-accounts.module').then((m) => m.ManageUserAccountsModule),
  },
  {
    path: 'admin/manage-assets',
    pathMatch: 'full',
    loadChildren: () =>
      import('./admin/manage-assets/manage-assets.module').then((m) => m.ManageAssetsModule),
  },
  {
    path: 'admin/manage-customers',
    pathMatch: 'full',
    loadChildren: () =>
      import('./admin/manage-customers/manage-customers.module').then((m) => m.ManageCustomersModule),
  },
  {
    path: 'admin/manage-sectors',
    pathMatch: 'full',
    loadChildren: () =>
      import('./admin/manage-sectors/manage-sectors.module').then((m) => m.ManageSectorsModule),
  },
  {
    path: 'admin/manage-section-roll-names',
    pathMatch: 'full',
    loadChildren: () =>
      import('./admin/manage-section-roll-names/manage-section-roll-names.module').then((m) => m.ManageSectionRollNamesModule),
  },
  {
    path: 'admin/manage-subsectors',
    pathMatch: 'full',
    loadChildren: () =>
      import('./admin/manage-subsectors/manage-subsectors.module').then((m) => m.ManageSubSectorsModule),
  },
  {
    path: 'admin/manage-application-systems',
    pathMatch: 'full',
    loadChildren: () =>
      import('./admin/manage-application-systems/manage-application-systems.module').then((m) => m.ManageApplicationSystemsModule),
  },
  {
    path: 'paper-machines',
    loadChildren: () =>
      import('./paper-machines/paper-machines.module').then(
        (m) => m.PaperMachinesModule
      ),
  },
  {
    path: 'cement-mining',
    loadChildren: () =>
      import('./cement-mining/cement-mining.module').then(
        (m) => m.CementMiningModule
      ),
  },
  {
    path: 'design',
    loadChildren: () =>
      import('./design/design.module').then((m) => m.DesignModule),
  },
  {
    path: 'rest-integration',
    pathMatch: 'full',
    loadChildren: () =>
      import('./rest-integration/rest-integration.module').then(
        (m) => m.RestIntegrationModule
      ),
  },
  {
    path: 'forbidden',
    pathMatch: 'full',
    loadChildren: () =>
      import('@schaeffler/empty-states').then((m) => m.ForbiddenModule),
  },
  {
    path: 'page-not-found',
    pathMatch: 'full',
    loadChildren: () =>
      import('@schaeffler/empty-states').then((m) => m.PageNotFoundModule),
  },
  {
    path: '**',
    redirectTo: `/page-not-found`,
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
